<template>
    <BaseSlideOver
        :model-value="model"
        :title="$t('notifications.title')"
        size="md"
        @update:model-value="model = $event">
        <NotificationFeed />
    </BaseSlideOver>
</template>

<script setup>
import {useNotificationStore} from "@/store/notifications"

const notificationStore = useNotificationStore()

// listen for new notifications
useEventBus('notifications').on((notification) => {
    notificationStore.refreshTimeline()
    useNotification().custom(
        notification.content,
        "user-plus",
        "",
        "",
        "info")
})

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    }
})

const emits = defineEmits(['update:modelValue'])

const model = computed({
    get: () => props.modelValue,
    set: (value) => emits('update:modelValue', value)
})
</script>